import classNames from "classnames/bind";
import styles from "./StreamCam.module.css";

const cx = classNames.bind(styles);
function ModalCountPositionCarPark({ detail, screen, fullScreen }) {
    const className = fullScreen ? "font-size-fullsc-" : 'font-size-';
    return (
        <div className={cx('content-modal', `${className}${screen}`)}>
            VT trống: <span className={cx('car-park-count')}>{detail?.total - detail?.count}</span> / {detail?.total}
        </div>
    )
}

export default ModalCountPositionCarPark;